import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { ASSET_DISABLE_METHODS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";
import DisposalMethodDialog from "./DisposalMethodDialog";


function DisposalMethod() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const showAlert = useAlert();

    const getAssetDisposalMethodsData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await AxiosInstance.get(`${ASSET_DISABLE_METHODS_URL}/all`);
            setData(response.data || []);
        } catch (error) {
            console.error("Error fetching Asset Disposal MEthods data:", error);
            setError("Failed to load Asset Disposal MEthods data. Please try again.");
            // showAlert("Failed to load statuses", "error");
        } finally {
            setLoading(false);
        }
    }, [showAlert]);

    useEffect(() => {
        getAssetDisposalMethodsData();
    }, [getAssetDisposalMethodsData]);

    const columns = [
        {
            field: "id",
            flex: 1,
            headerName: "Id",
            renderCell: (params) => params.value,
        },
        {
            field: "name",
            flex: 2,
            headerName: "Name",
            renderCell: (params) => params.value,
        },
        {
            field: "enabled",
            flex: 1,
            headerName: "Enabled",
            renderCell: (params) => params.value?"YES":"NO",
        },
        {
            field: "description",
            flex: 1,
            headerName: "Description",
            renderCell: (params) => params.value,
        },
        {
            field: "action",
            flex: 1,
            headerName: "Actions",
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <DisposalMethodDialog
                        assetDisposalMethodId={params.row.id}
                        assetDisposalMethodName="Edit"
                        variant="link"
                    />
                </Box>
            ),
        },
    ];

    //if error content
    if (error) {
        return (
            <Container>
                <Alert
                    severity="error"
                    action={
                        <Button color="inherit" size="small" onClick={getAssetDisposalMethodsData}>
                            Retry
                        </Button>
                    }
                    sx={{ borderRadius: 2 }}
                >
                    {error}
                </Alert>
            </Container>
        );
    }

    return (
        <Box
            sx={{
                borderRadius: "8px",
                overflow: "hidden",
                p: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            {/* loading or content */}
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (
                <AppTableView rows={data} cols={columns} initialPageSize={5} />
            )}
        </Box>
    );
}

export default DisposalMethod;
